module.exports = __webpack_public_path__ + "static/img/about-list2.36ce9b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-list2.png
// module id = 03EN
// module chunks = 0